import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';
import { PropertyType } from 'src/app/services/portal-api.service';


@Pipe({
  name: 'translateList',
  pure: true, // Ensure the pipe updates when language changes,
  standalone: true
})
export class TranslateListPipe implements PipeTransform {
  private lastValue: string | undefined;
  private lastResult: string = '';
  private langChangeSubscription!: Subscription;

  constructor(private translocoService: TranslocoService, private cdr: ChangeDetectorRef) {
    // Subscribe to language changes
    this.langChangeSubscription = this.translocoService.langChanges$.subscribe(() => {
      this.lastResult = this.transform(this.lastValue || '');
      this.cdr.markForCheck(); // Notify Angular to re-check the pipe's output
    });
  }

  transform(value: string | undefined, separator: string = ','): string {
    if (typeof value !== 'string' || !value.trim()) {
      return '';
    }

    this.lastValue = value;

    if (!value) {
      this.lastResult = '';
      return this.lastResult;
    }


    // Split the value into an array
    const items = value.split(separator).map(item => {
      return item.trim()
    });

    // Translate each item and join back with the separator
    const result = items
      .map(item => {
        if (PropertyType[`${item as PropertyType}`]) {
          const translation = this.translocoService.translateObject(`find-property.propertyType.${item}`);
          return translation;
        } 
        return item
      })
      .join(`${separator} `);
    return result;
  }

  ngOnDestroy(): void {
    // Clean up the subscription when the pipe is destroyed
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }
}
